import React from 'react'
import InfoBox from '@components/InfoBox'
import PropTypes from 'prop-types'
import { observer, PropTypes as mobxPropTypes } from 'mobx-react'
import { isInvoiceOverpaid } from '../calculateInvoiceAmount'

const InvoiceOverpaidNotification = ({ invoice, invoicePayments }) => {
  const isOverpaid = isInvoiceOverpaid({ ...invoice, invoicePayments })
  if (!isOverpaid) return null

  return (
    <InfoBox theme='yellow' className='m-t-xl m-b-xl'>
      Paid amount exceeds the invoice amount.
    </InfoBox>
  )
}

InvoiceOverpaidNotification.propTypes = {
  invoice: PropTypes.object,
  invoicePayments: PropTypes.oneOfType([
    PropTypes.array,
    mobxPropTypes.observableArray
  ])
}

export default observer(InvoiceOverpaidNotification)
